import {Tr} from '../../../_metronic/i18n/Tr'
import {Phone, Mail, MessageCircle, SendIcon} from 'lucide-react'

const ViewContact = () => {
  const t = Tr()
  return (
    <div className={`card `}>
      <div className='card-header align-items-start flex-column border-0 py-5'>
        <h1 className='card-title align-items-start flex-column mx-auto fs-1'>
          <span className='card-label fw-bolder mb-1 mt-5 mx-auto text-center' style={{fontSize: '46px'}}>
            {t('Get Immediate Support')}
          </span>
        </h1>
        <span className='fs-2 text-gray-600 mx-auto mb-5 text-center'>{t("Our team is here to help you 24/7")}</span>
        <div className='card-toolbar d-none d-md-block'>
          <div className='card card-custom'>
            <div className='card-header border-0 card-header-stretch'></div>
          </div>
        </div>
        <div className='row g-4 mb-5 w-100'>
          {/* Call Us */}
          <div className='col-md-6 col-lg-3 text-nowrap'>
            <div className='rounded-4 contactCard'>
              <div
                className='rounded-3 d-flex align-items-center justify-content-center mb-3'
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #5a98b4, #65c098)',
                }}
              >
                <Phone className='w-7 h-7 text-white' />
              </div>

              <h3 className='fs-1 fw-semibold text-dark mt-5 mb-4'>{t('Call Us')}</h3>

              <a
                href='tel:+998951204575'
                className='fw-medium d-block mb-1 fs-3'
                style={{color: '#5a98b4'}}
              >
                +998 95 120 45 75
              </a>

              <p className='text-muted'>(24/7 Available)</p>
            </div>
          </div>

          {/* Email Us */}
          <div className='col-md-6 col-lg-3 text-nowrap'>
            <div className='rounded-4 contactCard'>
              <div
                className='rounded-3 d-flex align-items-center justify-content-center mb-3'
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #5a98b4, #65c098)',
                }}
              >
                <Mail className='w-7 h-7 text-white' />
              </div>

              <h3 className='fs-1 fw-semibold text-dark mt-5 mb-4'>{t('Email Us')}</h3>

              <a
                href='mailto:support@insayr.uz'
                className='fw-medium d-block mb-1 fs-3'
                style={{color: '#5a98b4'}}
              >
                support@insayr.uz
              </a>

              <p className='text-muted'>(Response in 2-4 hours)</p>
            </div>
          </div>

          {/* Telegram */}
          <div className='col-md-6 col-lg-3 text-nowrap'>
            <div className='rounded-4 contactCard'>
              <div
                className='rounded-3 d-flex align-items-center justify-content-center mb-3'
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #5a98b4, #65c098)',
                }}
              >
                <MessageCircle className='w-7 h-7 text-white' />
              </div>

              <h3 className='fs-1 fw-semibold text-dark mt-5 mb-4'>{t('Telegram')}</h3>

              <a
                href='https://t.me/insayr_admin'
                target='_blank'
                rel='noopener noreferrer'
                className='fw-medium d-block mb-1 fs-3'
                style={{color: '#5a98b4'}}
              >
                @insayr_admin
              </a>

              <p className='text-muted'>(Instant messaging)</p>
            </div>
          </div>

          {/* WhatsApp */}
          <div className='col-md-6 col-lg-3 text-nowrap'>
            <div className='rounded-4 contactCard'>
              <div
                className='rounded-3 d-flex align-items-center justify-content-center mb-3'
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #65c098, #5a98b4)',
                }}
              >
                <SendIcon className='w-7 h-7 text-white' />
              </div>

              <h3 className='fs-1 fw-semibold text-dark mt-5 mb-4'>{t('Whatsapp')}</h3>

              <a
                href='https://wa.me/998951204575'
                target='_blank'
                rel='noopener noreferrer'
                className='fw-medium d-block mb-1 fs-3'
                style={{color: '#5a98b4'}}
              >
                +998 95 120 45 75
              </a>

              <p className='text-muted'>(Fast response)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewContact
